
import { memo, ReactNode, useRef, useState, useEffect, useMemo, useCallback } from 'react';
import { useGridColumns } from "./useGridColumns";
import { Table } from "components/Table";
import { Document, Property } from "types";
import { IndexableDocument } from "hooks/queries/useDocuments";
import { GridCellParams, GridFilterModel, GridSortModel, GridValueGetterParams } from '@mui/x-data-grid-pro';
import { Tag } from 'types/Tag';
import { TagCell } from 'components/TagCell';
import { TagConfig, WorkspaceConfig } from 'types/WorkspaceConfig';

export type FileTableProps = {
    documents: IndexableDocument[],
    workspaceConfig: WorkspaceConfig,
    properties: Property[],
    documentsCount: number,
    loading?: boolean,
    selection?: Document[],
    pageSize: number,
    sortOrder: GridSortModel,
    enableTags?: boolean,
    onNameClick?: (file: Document) => void,
    onSelection?: (selection: Document[]) => void,
    onPageChange: (newPageIndex: number) => void,
    onFilterChange?: (newFilterModel: GridFilterModel) => void,
    onSortChange?: (newSortModel: GridSortModel) => void,
    previewComponent?: (item: any, control: ReactNode) => JSX.Element,
}

export const FileTable = memo(FileTable_);

//TODO Merge with components/Table
//TODO rename with DocumenTable
function FileTable_(props: FileTableProps) {
    
    const { documents, workspaceConfig, properties, documentsCount, pageSize, sortOrder, selection, enableTags, onNameClick, onPageChange, onFilterChange, onSortChange } = props;

    const { gridColumns = [] } = useGridColumns({ onNameClick, properties, workspaceConfig }) || {};

    if (enableTags)
        gridColumns.push(tagColumn(workspaceConfig.tagConfig));

    return (
        <Table
            {...props}
            columns={gridColumns}
            items={documents || []}
            pageSize={pageSize || 0}
            rowCount={documentsCount || 0}
            selectedItems={selection}
            sortModel={sortOrder}
            onPageChange={onPageChange}
            onSortModelChange={onSortChange}
            onFilterChange={onFilterChange}
        />
    )
    function tagColumn(config: TagConfig) {
        return {
            field: config.sortPropertyName || 'tags',
            headerName: "Tags",
            flex: 1,
            resizable: true,
            sortable: !!config.sortPropertyName,
            disableColumnMenu: true,
            valueGetter: (params: GridValueGetterParams) => params.row.tags,
            renderCell: (params: GridCellParams<Tag[]>) => {
                const tags = params.value || [];
                return <TagCell tags={tags} />;
            }
        }
    }
}


